import React , { useEffect }from "react";
import { Link } from "react-router-dom"; // For SPA navigation

const BulkAndImprinting = () => {
  useEffect(() => {
    document.title = "Bulk & Imprinting | Workgear365";
  }, []);
  // ✅ Get logged-in user from localStorage
  const user = JSON.parse(localStorage.getItem("user"));

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10">
          {/* Header Section */}
          <div className="text-center mb-5 bulkheader">
            <h1 className="text-primary fw-bold mb-3">
              Bulk & Custom Imprinting Quotes
            </h1>
            <p className="lead text-muted">
              Get competitive pricing for bulk orders and custom imprinting services
            </p>
          </div>

          {/* Process Explanation */}
          <div className="card shadow-sm mb-5">
            <div className="card-body p-5">
              <div className="row">
                <div className="col-lg-8">
                  <h3 className="text-primary mb-4">
                    <i className="fa-solid fa-info-circle me-2"></i>
                    How to Request a Quote
                  </h3>
                  <div className="process-steps">
                    {[
                      {
                        title: "Register an Account",
                        desc: "Create an account to save your information and track your quote requests. If you submit a quote request without registering for an account first you will not be able to view or track your quotes as you can in an account.",
                      },
                      {
                        title: "Browse Our Products",
                        desc: "Explore our website and find the items you're interested in getting a bulk or custom imprinting quote on.",
                      },
                      {
                        title: "Add Items to Quote",
                        desc: 'Next to the "Add to Cart" button, you\'ll see an "Add To Quote Cart" button. Click it to add items to your quote request. Keep Browsing and adding items to this cart until you are done. Then click "Enter Item Details And Quantities Here"',
                      },
                      {
                        title: "Fill Required Information",
                        desc: "Specify imprinting options and any special requirements for your list of items. Then enter quantities required for each item and sizes. If you have items that have different printing requirements e.g. Printing Position or Print Types you will need to submit a separate quote.",
                      },
                      {
                        title: "Submit Your Request",
                        desc: "Click 'Submit For Quote' to send your request. We'll get back to you as soon as possible by email. Please check your spam mail if you do not receive a quote within 24 hours.",
                      },
                    ].map((step, idx) => (
                      <div key={idx} className="step mb-4 d-flex">
                        <div className="step-number">{idx + 1}</div>
                        <div className="step-content">
                          <h5 className="fw-bold">{step.title}</h5>
                          <p className="text-muted mb-0">{step.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="col-lg-4">
                  <div className="bg-light p-4 rounded">
                    <h5 className="text-primary mb-3">
                      <i className="fa-solid fa-envelope me-2"></i>
                      Alternative Method
                    </h5>
                    <p className="mb-3">Prefer to email us directly?</p>
                    <a
                      href="mailto:quoterequests@workgear365.com"
                      className="btn btn-outline-primary w-100 mb-2"
                    >
                      <i className="fa-solid fa-envelope me-2"></i>Email Quote Request
                    </a>
                    <p className="small text-muted mb-0">
                      Send your requirements to:{" "}
                      <strong>quoterequests@workgear365.com</strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Benefits Section */}
          <div className="row mb-5">
            {[
              {
                icon: "fa-users",
                color: "text-primary",
                title: "Bulk Pricing",
                desc: "Get competitive pricing for large quantity orders",
              },
              {
                icon: "fa-palette",
                color: "text-success",
                title: "Custom Imprinting",
                desc: "Professional logo and text imprinting services",
              },
              {
                icon: "fa-clock",
                color: "text-warning",
                title: "Quick Response",
                desc: "Fast turnaround on quote requests",
              },
            ].map((benefit, idx) => (
              <div key={idx} className="col-md-4 mb-4">
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body text-center p-4">
                    <div className="mb-3">
                      <i className={`fa-solid ${benefit.icon} fa-3x ${benefit.color}`}></i>
                    </div>
                    <h5 className="fw-bold">{benefit.title}</h5>
                    <p className="text-muted">{benefit.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Call to Action */}
          <div className="text-center">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <h4 className="mb-4">Ready to Get Started?</h4>
                <div className="d-flex flex-column flex-md-row gap-3 justify-content-center">
                  {user ? (
                    <>
                      <Link to="/home" className="btn btn-primary btn-lg">
                        <i className="fa-solid fa-shopping-bag me-2"></i> Browse Products
                      </Link>
                      <Link to="/my-quotes" className="btn btn-outline-primary btn-lg">
                        <i className="fa-solid fa-list me-2"></i> View My Quotes
                      </Link>
                    </>
                  ) : (
                    <>
                      <Link to="/registration" className="btn btn-primary btn-lg">
                        <i className="fa-solid fa-user-plus me-2"></i> Register Account
                      </Link>
                      <Link to="/login" className="btn btn-outline-primary btn-lg">
                        <i className="fa-solid fa-sign-in-alt me-2"></i> Login
                      </Link>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Inline styles */}
      <style>{`
        .process-steps .step {
          display: flex;
          align-items: flex-start;
        }
        .step-number {
          width: 40px;
          height: 40px;
          background: linear-gradient(135deg, #007bff, #0056b3);
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          margin-right: 20px;
          flex-shrink: 0;
        }
        .step-content h5 {
          margin-bottom: 8px;
        }
        .card {
          transition: transform 0.2s ease-in-out;
        }
        .card:hover {
          transform: translateY(-2px);
        }
      `}</style>
    </div>
  );
};

export default BulkAndImprinting;
